import React, { Component } from "react";

import { connect } from "react-redux";

import Render from "./Render";

class DesafiosTabs extends Component {
  componentWillMount() {
    if (typeof window !== "undefined") {
    }
  }

  render() {
    return <Render {...this.props} />;
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DesafiosTabs);



// WEBPACK FOOTER //
// ./src/components/DesafiosTabs/index.js